import React from 'react';

import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

import { getPrivilegeString } from '../../../utils/privileges';

const currentDate = new Date();

const MemberDetailsView = ({
    firstName,
    lastName,
    utuAccount,
    email,
    homeTown,
    privileges,
    membershipSince,
    membershipUntil,
    accepted,
    tyyMember,
}) => {
    const { t } = useTranslation();

    const membershipUntilFormatter = (membershipUntil, currentDate) => {
        if (membershipUntil) {
            if (new Date(membershipUntil) <= currentDate) {
                return (
                    <div>
                        {Moment(membershipUntil).format('D.M.YYYY')}{' '}
                        <FontAwesomeIcon
                            icon="exclamation-triangle"
                            color="red"
                        />
                    </div>
                );
            } else {
                return <div>{Moment(membershipUntil).format('D.M.YYYY')}</div>;
            }
        } else {
            return <div>{t('memberDetails.feeUnpaid')}</div>;
        }
    };

    const yesNoCell = (value) =>
        value ? (
            <p>
                {t('memberDetails.yes')}{' '}
                <FontAwesomeIcon icon="check" color="green" />
            </p>
        ) : (
            <p>
                {t('memberDetails.no')} <FontAwesomeIcon icon="times" color="red" />
            </p>
        );

    return (
        <div className="container">
            <Table striped hover>
                <tbody>
                    <tr>
                        <th>{t('memberDetails.firstName')}</th>
                        <td style={{ textTransform: 'capitalize' }}>
                            {firstName}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.lastName')}</th>
                        <td>{lastName}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.utuAccount')}</th>
                        <td>{utuAccount}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.email')}</th>
                        <td>{email}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.homeTown')}</th>
                        <td>{homeTown}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.tyyMember')}</th>
                        <td>{yesNoCell(tyyMember)}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.roles')}</th>
                        <td>{getPrivilegeString(privileges)}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.membershipAccepted')}</th>
                        <td>{yesNoCell(accepted)}</td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.membershipSince')}</th>
                        <td>
                            {membershipSince
                                ? Moment(membershipSince).format('D.M.YYYY')
                                : t('memberDetails.feeUnpaid')}
                        </td>
                    </tr>
                    <tr>
                        <th>{t('memberDetails.membershipUntil')}</th>
                        <td>
                            {membershipUntilFormatter(
                                membershipUntil,
                                currentDate
                            )}
                        </td>
                    </tr>
                </tbody>
            </Table>
            <div>
                {membershipUntil && new Date(membershipUntil) <= currentDate ? (
                    <p>
                        <FontAwesomeIcon
                            icon="exclamation-triangle"
                            color="red"
                        />{' '}
                        {t('memberDetails.membershipEnded')}
                    </p>
                ) : null}
            </div>
            <Link className="btn btn-success success" to={`/member/update/`}>
                {t('memberDetails.update')}
            </Link>
        </div>
    );
};

export default MemberDetailsView;
